import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import DDMNavBar from '@/externals/ddm/components/DDMNavBar';
import { DialogContainer } from '@/modules/MuiDialog';

const DDMLayout = () => {
    return (
        <>
            <Box
                sx={{
                    minHeight: '100vh',
                    backgroundColor: '#fff',
                }}
            >
                <DDMNavBar />
                <Box>
                    <Outlet />
                </Box>
            </Box>
            <DialogContainer />
        </>
    );
};

export default DDMLayout;
